import { funnelFoxEventSchema, webhookResponseSchema } from '@inkitt/contracts-common';
import type Stripe from 'stripe';
import { z } from 'zod';
import { c } from '../../../contract';

export const funnelFoxRouter = c.router(
  {
    event: {
      summary: "FunnelFox's webhook endpoint",
      method: 'POST',
      path: '/event',
      body: funnelFoxEventSchema,
      responses: webhookResponseSchema,
    },
    funnelFoxStripePurchase: {
      summary: "FunnelFox's webhook endpoint",
      method: 'POST',
      path: '/funnelfox-stripe-purchase',
      body: c.type<Stripe.Event>(),
      responses: {
        200: z.object({
          message: z.string(),
        }),
        500: z.object({
          message: z.string(),
        }),
      },
    },
  },
  { pathPrefix: '/funnelfox' },
);
